const Dice = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 6A2.5 2.5 0 0 1 6 3.5h12A2.5 2.5 0 0 1 20.5 6v12a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 18zM6 4.5A1.5 1.5 0 0 0 4.5 6v12A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 18 4.5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.5 8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M17 8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M9.5 15.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M17 15.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M13.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
    />
  </>
)
export default Dice
